import {
  Datagrid,
  TextField,
  ReferenceField,
  useTranslate,
  FunctionField,
  ShowButton,
  EditButton,
  BooleanField,
  ImageField,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  CreateOnlyTopToolbar,
  CustomList,
} from "../../shared/components/index.js";

const listMerchantPaymentGateways = () => {
  const t = useTranslate();
  const merchant = localStorage.getItem("name");

  return (
    <CustomList actions={<CreateOnlyTopToolbar />}>
      <Datagrid rowClick={false} bulkActionButtons={false}>
        {merchant === "PetrolCard" && (
          <ReferenceField source="logo_file_id" reference="File">
            <ImageField
              source="url"
              sx={{
                "& img": { maxWidth: 30, maxHeight: 30, objectFit: "contain" },
              }}
            />
          </ReferenceField>
        )}
        <ReferenceField source="payment_gateway_id" reference="PaymentGateway">
          <TextField source="name" />
        </ReferenceField>
        <BooleanField
          source="default"
          sx={{
            "& .RaBooleanField-trueIcon": {
              color: "green",
            },
            "& .RaBooleanField-falseIcon": {
              color: "red",
            },
          }}
        />
        <JsonField
          source="config"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Merchant.source.status.${record.status}`)
          }
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <ShowButton className="button-show" />
        <EditButton className="button-edit" />
      </Datagrid>
    </CustomList>
  );
};

export default listMerchantPaymentGateways;
